import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { oc } from 'ts-optchain';

export const practicesSelector = (state: RootState) => state.amwell.activeConsumer.practices;

export const practicesListDataSelector = createSelector(practicesSelector, p =>
  oc(p).list.practices([])
);
export const practiceCategoriesListDataSelector = createSelector(practicesSelector, p =>
  oc(p).list.practiceCategories([])
);
export const practicesListDataErrorSelector = createSelector(practicesSelector, p => p.list.error);
export const practicesListDataLoadingSelector = createSelector(
  practicesSelector,
  p => p.list.loading
);

export const practiceDetailsDataSelector = createSelector(practicesSelector, p => p.details.data);
export const practiceDetailsDataErrorSelector = createSelector(
  practicesSelector,
  p => p.details.error
);
export const practiceDetailsDataLoadingSelector = createSelector(
  practicesSelector,
  p => p.details.loading
);
export const practiceServiceKeySelector = createSelector(practicesSelector, p => p.serviceKey);
